// P2b tanda 5 — cliente de las guías de tallas (proxy del backend al tema
// Vitrina, contrato v0.7.156). Cuando el tema no está activo en la tienda, el
// backend responde { disponible: false, motivo } y la pestaña se deshabilita
// con ese motivo — no es un error.

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

async function pedir(ruta, opts = {}) {
  const res = await fetch(`${API_URL}${ruta}`, {
    headers: { 'Content-Type': 'application/json' },
    ...opts,
    body: opts.body === undefined ? undefined : JSON.stringify(opts.body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || 'Error al hablar con las guías de tallas');
    err.code = data.code || null;
    throw err;
  }
  return data;
}

// → { disponible, motivo?, guias: [...] }
export function listarGuias() { return pedir('/api/catalog/guias'); }
export function obtenerGuia(id) { return pedir(`/api/catalog/guias/${id}`); }
// body: { titulo, tabla: {columnas, filas} (OBJETO, nunca string), imagenes: [ids], notas, categorias: [term_ids] }
export function crearGuia(body) { return pedir('/api/catalog/guias', { method: 'POST', body }); }
export function actualizarGuia(id, body) { return pedir(`/api/catalog/guias/${id}`, { method: 'PUT', body }); }
export function borrarGuia(id) { return pedir(`/api/catalog/guias/${id}`, { method: 'DELETE' }); }
// → { disponible, origen, guia_id, titulo, tabla, ... } (árbitro del theme)
export function guiaDeProducto(productId) { return pedir(`/api/products/${productId}/guia`); }
// Tanda 6: las categorías del WordPress DE GUÍAS (modo híbrido: el editor
// traduce las marcadas contra esta lista por slug/nombre antes de enviar).
export function listarGuiasCategorias() { return pedir('/api/catalog/guias-categorias'); }
